<template>
  <div id="emergency-support">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="image" v-for="(value, index) in images" :key="index">
        <img v-show="index!==5" v-bind:src="value" />
        <div class="video-box" v-show="index===5">
          <div class="content">
            <div class="video-info" v-for="(value,index) in videoList" :key="index" @click="videoClick(index)">
              <img :src="value.video_cover" />
              <div class="icon"></div>
              <div class="title">{{value.title}}</div>
              <div class="subtitle">{{value.description}}</div>
            </div>
          </div>
        </div>
        <div class="news-button" v-show="index===2" @click="newsClick">查看详情</div>
      </div>
    </div>
    <bottomButton v-show="1" title="方案咨询" state="1" @click="bottomClick"></bottomButton>
    <videoView :show="showVideo" :videoUrl="videoUrl" @closeVideo="closeVideoClick"></videoView>
    <AlertView :show="showAlert" title="提示" :subTitle="alertTitle" cancelTitle="重新下单" sureTitle="查看订单"
      @alertViewClick="alertViewClick"></AlertView>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button4'
import videoView from '../components/video-view'
import AlertView from '../components/alert-view'
// import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      showVideo: false,
      showAlert: false,
      alertTitle: '您有1个未完成的订单，是否进入？',
      isLogin: 0,
      // images: [
      //   require('../assets/icon-security1.jpg'),
      //   require('../assets/icon-security2.jpg'),
      //   require('../assets/icon-security3.jpg'),
      //   require('../assets/icon-security4.jpg'),
      //   require('../assets/icon-security4.jpg'), // 视频占位
      //   require('../assets/icon-security5.jpg'),
      //   require('../assets/icon-security6.jpg'),
      //   require('../assets/icon-security7.jpg'),
      //   require('../assets/icon-security8.jpg')],
      images: [
        require('../assets/1.jpg'),
        require('../assets/2.jpg'),
        require('../assets/3.jpg'),
        require('../assets/4.jpg'),
        require('../assets/5.jpg'),
        require('../assets/4.jpg'),

        require('../assets/6.jpg')
      ],
      videoList: [],
      videoUrl: '',
      orderType: 0, // 0 无未支付订单  1 有一条订单 2 有多条订单
      orderData: []
    }
  },
  methods: {
    logoutClick: function () {
      // this.$router.push({path: 'home'})
    },
    forId: function (type, index) {
      if (type === 1) {
        return 'contentImage' + index
      }
      if (type === 2) {
        return 'image-left' + index
      }
      if (type === 3) {
        return 'image-right' + index
      }
    },
    alertViewClick: function (index) {
      this.showAlert = false
      console.log('index-----------' + index + '====' + this.orderType)
      // 重新下单
      if (index === 0) {
        localStorage.removeItem('planInfo')
        this.$router.push({ path: 'emergency-plan1' })
      }
      // 查看订单
      if (index === 1) {
        // 一个订单
        if (this.orderType === 1) {
          this.$router.push({ path: 'emergency-detail', query: { planId: this.orderData[0].solutionsId } })
        }
        // 多个订单
        if (this.orderType === 2) {
          this.$router.push({ path: 'orderlist' })
        }
      }
    },
    videoClick: function (index) {
      this.showVideo = true
      this.videoUrl = this.videoList[index].video_url
    },
    closeVideoClick: function () {
      this.showVideo = false
      this.videoUrl = ''
    },
    newsClick: function () {
      // this.$router.push({path: 'webview', query: {url: 'https://mp.weixin.qq.com/s/tHbOf8IVs8XjyOpiQpQk5g'}})
      if (this.isLogin === 1 && parseInt(this.$route.query.isApp) === 1) {
        if (this.utils.isIphone()) { // ios
          window.webkit.messageHandlers.newsDetail.postMessage('')
        } else {
          window.zxzx.newsDetail()
        }
      } else {
        window.location.href = 'https://m.zxzx119.com/news-info?newsID=13835'
      }
    },
    bottomClick: function () {
      if (this.isLogin === 0) {
        Toast('您还未登录，请登录后再咨询！')
        this.$router.push({ path: 'login', query: { back: 1 } })
      } else {
        //
        this.orderStateEvent()
      }
    },
    loadData: function () {
      // 视频列表
      var _this = this
      this.utils.GET('https://app.zxzx119.com/consultingVideo/videoUrlList', function (response) {
        _this.videoList = response.data
      })
    },
    loadOrderState: function () {
      // 获取 方案咨询订单状态
      var _this = this
      this.utils.GET(this.accountUrl + '/zxOrder/consultingOrdersData', function (response) {
        _this.orderType = parseInt(response.data.type)
        if (_this.orderType === 1) {
          _this.orderData[0] = response.data.orderData
        }
        if (_this.orderType === 2) {
          _this.orderData = response.data.ordersData
        }
        if (_this.orderType !== 0) {
          _this.orderStateEvent()
        }
        _this.alertTitle = '您有' + _this.orderData.length + '个未完成的订单，是否进入？'
      })
    },
    orderStateEvent: function () {
      if (this.orderType === 0) {
        this.$router.push({ path: 'emergency-plan1' })
      }
      if (this.orderType === 1) {
        this.showAlert = true
        // this.$router.push({path: 'emergency-plan1'})
      }
      if (this.orderType === 2) {
        this.showAlert = true
        // this.$router.push({path: 'emergency-plan1'})
      }
    }
  },
  components: {
    mainHeader,
    bottomButton,
    videoView,
    AlertView
  },
  mounted () {
    this.loadData()

    this.isLogin = parseInt(localStorage.getItem('isLogin'))
    if (this.isLogin === 1 || parseInt(this.$route.query.isApp) === 1) {
      this.isLogin = 1
      this.loadOrderState()
    } else {
      this.isLogin = 0
    }
    // 微信 分享
    // let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    // wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
  }
}
</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper {
  position: relative;
  background-color: #f6f6f6;
  margin-top: 55px;
  margin-bottom: 65px;
  width: 100%;
}
.image {
  position: relative;
  margin-top: -1px;
}
img {
  position: relative;
  width: 100%;
  display: block;
}
.video-box {
  position: relative;
  height: 250px;
  padding: 15px;
  width: 100%;
  overflow-x: scroll;
  background-color: #c41335;
}
.video-box .content {
  position: absolute;
  width: 1740px;
  overflow: hidden;
}
.video-box .content .video-info {
  position: relative;
  float: left;
  width: 275px;
  height: 220px;
  margin-right: 15px;
}
.video-box .content .video-info img {
  width: 275px;
  height: 160px;
}
.video-box .content .video-info .icon {
  position: absolute;
  top: 60px;
  left: 117px;
  width: 40px;
  height: 40px;
  background-image: url("../assets/icon-play.png");
  background-size: cover;
  background-position: center;
}
.video-box .content .video-info .title {
  margin-top: 5px;
  width: 275px;
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  font-size: 16px;
}
.video-box .content .video-info .subtitle {
  width: 275px;
  height: 15px;
  line-height: 15px;
  color: #fecdcd;
  font-size: 12px;
}
.news-button {
  position: absolute;
  bottom: 210px;
  left: 30px;
  right: 30px;
  height: 40px;
  line-height: 40px;
  background-color: #c41335;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/view/emergency-support.vue